
define('text!plugins/textbox/setupTemplate.html',[],function () { return '';});

